{
  "title": "Konto erstellen",
  "subtitle": "Registriere dich, um loszulegen",
  "emailLabel": "E-Mail",
  "passwordLabel": "Passwort",
  "confirmPasswordLabel": "Passwort bestätigen",
  "signUpButton": "Anmelden",
  "requirementsText": "Mindestens 8 Zeichen mit Groß-, Kleinbuchstaben und Zahlen",
  "strengthLabel": "Stärke: {{strength}}",
  "passwordStrength": {
    "tooShort": "Zu kurz",
    "weak": "Schwach",
    "fair": "Okay",
    "good": "Gut",
    "strong": "Stark"
  },
  "alreadyHaveAccount": "Bereits ein Konto?",
  "logIn": "Anmelden",
  "errors": {
    "invalidEmail": "Bitte gib eine gültige E-Mail-Adresse ein",
    "tooShort": "Passwort muss mindestens 8 Zeichen haben",
    "needsUppercase": "Passwort muss mindestens einen Großbuchstaben enthalten",
    "needsLowercase": "Passwort muss mindestens einen Kleinbuchstaben enthalten",
    "needsNumber": "Passwort muss mindestens eine Zahl enthalten",
    "noMatch": "Passwörter stimmen nicht überein",
    "createFailed": "Konto konnte nicht erstellt werden",
    "createFailedRetry": "Konto konnte nicht erstellt werden. Bitte versuche es erneut.",
    "genericError": "Ein Fehler ist aufgetreten. Bitte versuche es erneut."
  }
}
